import { getToken } from "firebase/messaging";
import { initializeMessaging, vapidKey } from "./config";
import { errorMsg } from "../utils/toastMessage";

const requestToken = async () => {
  let firebaseToken = "";
  try {
    firebaseToken = await getToken(initializeMessaging(), { vapidKey });
  } catch (error) {
    if (error.code === "messaging/permission-blocked") {
      errorMsg("Notification permission denied");
    }
    console.log("firebase getToken error", error);
  }

  return firebaseToken;
};

export default requestToken;
